(function () {
  // hard debug so you KNOW the asset is executing
  console.log("[chai-guard] asset loaded", {
    href: location.href,
    ts: Date.now(),
  });

  if (window.Shopify && Shopify.designMode) return;
  if (window.__chaiBundleGuardInit) return;
  window.__chaiBundleGuardInit = true;

  var BUNDLE_KEY = "chai-starter-kit";
  var MAIN_PRODUCT_ID = Number(window.__CHAI_MAIN_PRODUCT_ID || 0);

  console.log("[chai-guard] init", {
    MAIN_PRODUCT_ID: MAIN_PRODUCT_ID,
    BUNDLE_KEY: BUNDLE_KEY,
  });

  // Prevent concurrent refreshes
  var isRefreshing = false;

  async function fetchCart() {
    var r = await fetch("/cart.js", {
      headers: { Accept: "application/json" },
    });
    return await r.json();
  }

  function updateHeaderCartBubble(cart) {
    try {
      var bubble = document.querySelector(
        "#cart-icon-bubble .cart-count-bubble",
      );
      if (!bubble) return;

      var count = Number(cart && cart.item_count) || 0;
      var visible = bubble.querySelector('span[aria-hidden="true"]');
      var sr = bubble.querySelector("span.visually-hidden");

      if (visible) visible.textContent = String(count);
      if (sr) sr.textContent = count === 1 ? "1 item" : count + " items";
      bubble.style.display = count > 0 ? "" : "none";
    } catch (e) {
      console.warn("[chai-guard] bubble update failed", e);
    }
  }

  async function lockAddonQuantityUI() {
    try {
      var cart = await fetchCart();
      var items = cart.items || [];

      // For each addon bundle line, lock the quantity UI by cart index (1-based)
      items.forEach(function (it, idx) {
        var props = it.properties || {};
        if (!(props._bundle === BUNDLE_KEY && props._role === "addon")) return;

        var lineIndex = idx + 1;

        // Works on CartDrawer + Cart page (anywhere the theme uses data-index)
        var inputs = document.querySelectorAll(
          'input.quantity__input[data-index="' + lineIndex + '"]',
        );
        inputs.forEach(function (input) {
          var qi = input.closest("quantity-input");
          if (!qi) return;

          qi.querySelectorAll("button.quantity__button").forEach(
            function (btn) {
              btn.disabled = true;
              btn.classList.add("disabled");
              btn.setAttribute("aria-disabled", "true");
              btn.style.pointerEvents = "none";
              btn.style.opacity = "0.5";
            },
          );

          input.setAttribute("readonly", "readonly");
          input.setAttribute("min", "1");
          input.setAttribute("max", "1");
          input.value = "1";
          input.style.pointerEvents = "none";

          // optional: hide completely instead of disable
          qi.style.display = "none";
        });
      });
    } catch (e) {
      console.warn("[chai-guard] lockAddonQuantityUI failed", e);
    }
  }

  function getDrawerInner() {
    return document.querySelector("#CartDrawer");
  }

  async function refreshDrawerHtml() {
    // Prevent concurrent refreshes
    if (isRefreshing) {
      console.log("[chai-guard] already refreshing, skipping");
      return;
    }

    isRefreshing = true;

    try {
      var oldEl = getDrawerInner();
      if (!oldEl) {
        console.warn("[chai-guard] no drawer element found");
        return;
      }

      console.log("[chai-guard] fetching fresh drawer HTML");

      var res = await fetch(window.location.pathname + window.location.search, {
        headers: { Accept: "text/html" },
      });

      if (!res.ok) {
        console.error("[chai-guard] fetch failed", res.status);
        return;
      }

      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, "text/html");
      var newEl = doc.querySelector("#CartDrawer");

      if (newEl) {
        console.log("[chai-guard] updating drawer HTML");
        oldEl.innerHTML = newEl.innerHTML;

        // Lock addon quantities after refresh
        setTimeout(lockAddonQuantityUI, 100);
      } else {
        console.warn("[chai-guard] no #CartDrawer found in fetched HTML");
      }
    } catch (e) {
      console.error("[chai-guard] drawer refresh failed", e);
    } finally {
      isRefreshing = false;
    }
  }

  function openSwiperDrawerIfOpenish() {
    var cd = document.querySelector("cart-drawer");
    if (!cd) return;

    // if it's currently open via class, keep it that way after html replace
    if (cd.classList.contains("active")) {
      cd.classList.add("active");
      cd.classList.remove("is-empty");
    }
  }

  async function enforceGuard() {
    if (!MAIN_PRODUCT_ID) {
      console.warn("[chai-guard] MAIN_PRODUCT_ID missing, skipping");
      return;
    }

    var cart = await fetchCart();
    var items = cart.items || [];

    var addonLines = items.filter(function (it) {
      var props = it.properties || {};
      return props._bundle === BUNDLE_KEY && props._role === "addon";
    });

    if (!addonLines.length) return;

    var hasMain = items.some(function (it) {
      return Number(it.product_id) === MAIN_PRODUCT_ID;
    });
    if (hasMain) return;

    console.log(
      "[chai-guard] removing orphan addon lines",
      addonLines.map(function (l) {
        return l.key;
      }),
    );

    var updates = {};
    addonLines.forEach(function (it) {
      updates[it.key] = 0;
    });

    var res = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ updates: updates }),
    });
    if (!res.ok) return;

    var fresh = await fetchCart();
    updateHeaderCartBubble(fresh);

    // Force drawer HTML refresh
    await refreshDrawerHtml();
    openSwiperDrawerIfOpenish();
  }

  async function enforceAddonQtyOne() {
    try {
      var cart = await fetchCart();
      var items = cart.items || [];

      var updates = {};
      items.forEach(function (it) {
        var props = it.properties || {};
        if (props._bundle === BUNDLE_KEY && props._role === "addon") {
          if (Number(it.quantity) !== 1) updates[it.key] = 1;
        }
      });

      if (!Object.keys(updates).length) return;

      console.log("[chai-guard] forcing addon qty -> 1", updates);

      var res = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ updates: updates }),
      });
      if (!res.ok) return;

      var fresh = await fetchCart();
      updateHeaderCartBubble(fresh);

      // refresh UI so it snaps back visually
      await refreshDrawerHtml();
      openSwiperDrawerIfOpenish();
    } catch (e) {
      console.warn("[chai-guard] enforceAddonQtyOne failed", e);
    }
  }

  async function runQtyProtection() {
    await lockAddonQuantityUI();
    await enforceAddonQtyOne();
  }

  // Listen for cart updates from other scripts - REFRESH DRAWER IMMEDIATELY
  document.addEventListener("cart:updated", function () {
    console.log("[chai-guard] heard cart:updated, refreshing drawer");
    refreshDrawerHtml();
    setTimeout(runQtyProtection, 250);
  });

  document.addEventListener("cart:refresh", function () {
    console.log("[chai-guard] heard cart:refresh, refreshing drawer");
    refreshDrawerHtml();
    setTimeout(runQtyProtection, 250);
  });

  // Run qty protection on load
  setTimeout(runQtyProtection, 700);

  // specifically after qty changes (plus/minus + manual input)
  document.addEventListener("click", function (e) {
    var qtyBtn = e.target.closest(
      'quantity-input button[name="plus"], quantity-input button[name="minus"]',
    );
    if (!qtyBtn) return;
    setTimeout(runQtyProtection, 350);
  });

  document.addEventListener("change", function (e) {
    if (!e.target.matches("quantity-input input.quantity__input")) return;
    setTimeout(runQtyProtection, 450);
  });

  // Guard enforcement
  setTimeout(enforceGuard, 350);

  document.addEventListener("click", function (e) {
    var removeBtn =
      e.target.closest("cart-remove-button button") ||
      e.target.closest("[data-cart-remove]") ||
      e.target.closest('a[href*="cart/change"]') ||
      e.target.closest('button[name="minus"]');

    if (!removeBtn) return;
    setTimeout(enforceGuard, 600);
  });
})();
